var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('h4',{staticClass:"mt-0 mb-1"},[_vm._v("Profile")]),_c('profile-form',{attrs:{"loading":_vm.loading,"user":_vm.user},on:{"submit":_vm.editProfile}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }